module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 list-paragraph",
    attrs: {
      "id": "references-2"
    }
  }, [_c('h1', {
    staticClass: "list-paragraph"
  }, [_vm._v("References")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Aas, K (1972):")]), _vm._v(" Biochemical and Immunological Basis of Bronchial Asthma. American Lecture Series. CC Thomas, Springfield USA. ISBN 0-398-02213-54.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Aas, K (2011):")]), _vm._v(" Miljøhemming. En skjult funksjonshemming. Kolofon Publisher, Oslo. ISBN 978-82-300-0835-5. "), _c('a', {
    attrs: {
      "href": "http://www.inneklima.com/index.asp?context=99&document=667",
      "target": "_blank"
    }
  }, [_vm._v("Environment-induced disability, an invisible handicap. (Summary in English).")]), _vm._v(" Free Norwegian web version.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kopot, A")]), _vm._v(" "), _c('strong', [_vm._v("(2014):")]), _vm._v(" AK lectures: "), _c('a', {
    attrs: {
      "href": "http://www.aklectures.com/subject/organic-chemistry",
      "target": "_blank"
    }
  }, [_vm._v("Organic chemistry")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kopot, A")]), _vm._v(" ("), _c('strong', [_vm._v("2014):")]), _vm._v(" AK lectures: "), _c('a', {
    attrs: {
      "href": "http://www.aklectures.com/subject/general-chemistry",
      "target": "_blank"
    }
  }, [_vm._v("General chemistry")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Pall ML (2007):")]), _vm._v(" Nitric oxide synthase partial uncoupling as a key switching mechanism for the NO/ONOO - cycle. Med Hypotheses; 69: 821 – 5. "), _c('a', {
    attrs: {
      "href": "http://www.ncbi.nlm.nih.gov/pubmed/?term=Nitric+oxide+synthase+partial+uncoupling+as+a+key+switching+mechanism+for+the+NO%2FONOO+-+cycle",
      "target": "_blank"
    }
  }, [_vm._v("Abstract")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Pall ML (2013):")]), _vm._v(" Electromagnetic fields act via activation of voltage-gated calcium channels to produce beneficial or adverse effects. J Cell Mol Med; 17: 958 – 65. "), _c('a', {
    attrs: {
      "href": "http://www.ncbi.nlm.nih.gov/pmc/articles/PMC3780531/",
      "target": "_blank"
    }
  }, [_vm._v("Free article")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Rossi A")]), _vm._v(" "), _c('strong', [_vm._v("(2014):")]), _vm._v(" The-ion-channel-through-the-keyhole. The naked scientist. University of Cambridge. "), _c('a', {
    attrs: {
      "href": "http://www.thenakedscientists.com/HTML/articles/article/the-ion-channel-through-the-keyhole/",
      "target": "_blank"
    }
  }, [_vm._v("Free website article")]), _vm._v(", Sun, 19th Oct 2008.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bb1f502","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch012.vue
// module id = 96
// module chunks = 0